import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string,
    onClick?: () => void
    dataTest?: string
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const EditIcon = observer('EditIcon', ({className, dataTest, onClick}: PropsType): React.ReactElement => {
    return (
        <SvgElement
            className={className}
            width='24'
            height='24'
            fill='#fff'
            onClick={onClick}
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            data-test={dataTest}

        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='m16.815 8.26-1.074-1.075c-.262-.262-.705-.243-.99.041l-1.009 1.01 2.023 2.022 1.009-1.01c.284-.284.303-.727.041-.989ZM9.93 16.105l-2.035-2.035 5.57-5.571 2.036 2.035-5.57 5.571ZM7 17l.707-2.576 1.869 1.87L7 17Z'
                fill='#fill'
            />
        </SvgElement>
    );
});
